// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"f826c328","379":"8aa1c353","498":"b06bc96d","703":"8f8f36fd"}[chunkId] + ".chunk.js";
};